import { useSelector } from 'react-redux';
import React, { useCallback, useEffect, useState } from 'react';

import { useMediaQuery, Button, Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { CircleLoading } from 'shared';
import { useThemeToggle } from '../../hooks/useThemeToggle';
import { useCompanyService } from '../../store/services/company.service';

const SecondSubscription = () => {
    const { themeMode } = useThemeToggle();
    const isDarkMode = themeMode === 'dark' ? true : false;
    const publishableKey = process.env.REACT_APP_STRIPE_INTENT;
    const publishableKeyInvoicePlan = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_INVOICE;
    const isScreenLowerThan1024 = useMediaQuery('(max-width: 1025px)');
    const pricingTableId = process.env.REACT_APP_STRIPE_PRICING_TABLE_ID;
    const pricingTableIdInvoice = process.env.REACT_APP_STRIPE_PRICING_TABLE_ID_INVOICE;
    const { createStripeSession, getStripeTableSession } = useCompanyService();

    const [stripeSession, setStripeSession] = useState(null);
    const companyData = useSelector((state) => state.company.data);
    const { user } = useSelector((state) => state.auth);
    const [referralId, setReferralId] = useState(null);
    const showOnlyInvoicePlan = companyData?.is_invoice_reconciler ? false : true;

    const handleCreateStripeSession = useCallback(async () => {
        const response = await createStripeSession(companyData?.id);

        if (response.url) {
            window.location.href = response.url;
        }
    }, [createStripeSession]);

    const handleStripeSession = async () => {
        try {
            const response = await getStripeTableSession(companyData?.id);
            setStripeSession(response.data);

        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://js.stripe.com/v3/pricing-table.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    useEffect(() => {
        if (companyData) {
            handleStripeSession();
        }
    }, [referralId, companyData]);

    const handleSkip = (e) => {
        e.preventDefault();
        // navigate('/purchases', { replace: true });
        window.history.back();
    };

    return stripeSession ? (
        <div>
            <Box
                sx={{
                    position: 'absolute',
                    top: 16,

                    zIndex: 1,
                }}
            >
                <Button
                    variant="text"
                    onClick={handleSkip}
                    startIcon={<ArrowBackIcon />}
                    sx={{
                        color: isDarkMode ? '#F9FAFB' : '#121826',
                        textTransform: 'none',
                        fontWeight: 500,
                        '&:hover': {
                            backgroundColor: isDarkMode
                                ? 'rgba(255, 255, 255, 0.08)'
                                : 'rgba(0, 0, 0, 0.04)',
                        },
                    }}
                >
                    Back
                </Button>
            </Box>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                }}
            >
                <button
                    onClick={handleCreateStripeSession}
                    style={{
                        color: 'grey',
                        backgroundColor: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        fontSize: '16px',
                        marginBottom: '30px',
                        marginLeft: '30px',
                    }}
                >
                    Manage Billing
                </button>
            </div>

            {!showOnlyInvoicePlan && (
                <>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            textAlign: 'center',
                            flexDirection: 'column',
                            margin: '5px 25px',
                        }}
                    >
                        <p
                            style={{
                                fontWeight: '700px',
                                fontSize: isScreenLowerThan1024 ? '20px' : '24px',
                                color: isDarkMode ? '#F9FAFB' : '#121826',
                                margin: '0px',
                            }}
                        >
                            Start with a 14-Day Free Trial. Full access. No risk. Cancel Anytime.
                        </p>

                        <p style={{ margin: '0px' }}>
                            Your card won't be charged until trial period is over.
                        </p>
                    </div>
                    <stripe-pricing-table
                        pricing-table-id={pricingTableId}
                        publishable-key={publishableKey}
                        customer-session-client-secret={stripeSession?.client_secret}
                        client-reference-id={referralId}
                    >
                        {!showOnlyInvoicePlan && (
                            <script
                                type="application/json"
                                data-stripe-subscription-data='{"trial_period_days":14}'
                            ></script>
                        )}
                    </stripe-pricing-table>

                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            margin: '10px 25px 20px 25px',
                        }}
                    >
                        <div
                            style={{
                                maxWidth: '800px',
                                textAlign: 'left',
                                color: isDarkMode ? '#F9FAFB' : '#121826',
                            }}
                        >
                            <p
                                style={{
                                    fontSize: '14px',
                                }}
                            >
                                *Currently Skybox supported
                            </p>

                            <p
                                style={{
                                    margin: '0 0 7px 0',
                                    fontSize: '14px',
                                }}
                            >
                                Additional Usage Charges (if monthly limits are exceeded):
                            </p>

                            <ul
                                style={{
                                    listStyle: 'none',
                                    padding: '0',
                                    margin: '0',
                                }}
                            >
                                <li
                                    style={{
                                        marginBottom: '2px',
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                    }}
                                >
                                    <span style={{ marginRight: '8px' }}>•</span>
                                    <span
                                        style={{
                                            fontSize: '14px',
                                        }}
                                    >
                                        Emails: $0.005 per email
                                    </span>
                                </li>

                                <li
                                    style={{
                                        marginBottom: '8px',
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                    }}
                                >
                                    <span style={{ marginRight: '8px' }}>•</span>
                                    <span
                                        style={{
                                            fontSize: '14px',
                                        }}
                                    >
                                        Purchase inventory upload: $0.005 per entry
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </>
            )}

            {showOnlyInvoicePlan && (
                <>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            textAlign: 'center',
                            flexDirection: 'column',
                            margin: '0 25px',
                        }}
                    >
                        <p
                            style={{
                                fontWeight: '700px',
                                fontSize: isScreenLowerThan1024 ? '20px' : '24px',
                                color: isDarkMode ? '#F9FAFB' : '#121826',
                                margin: '0px',
                            }}
                        >
                            Invoice Reconciler Plans
                        </p>
                        <p style={{ margin: '0 0 20px 0' }}>
                            Choose the plan that works best for your business
                        </p>
                    </div>
                    <stripe-pricing-table
                        pricing-table-id={pricingTableIdInvoice}
                        publishable-key={publishableKeyInvoicePlan}
                        customer-session-client-secret={stripeSession?.client_secret}
                    ></stripe-pricing-table>
                </>
            )}
        </div>
    ) : (
        <CircleLoading />
    );
};

export default SecondSubscription;
